module.exports = __webpack_public_path__ + "img/250095b.svg";